<template>
  <v-btn
    v-scroll="onScroll"
    v-show="fab"
    fab
    dark
    fixed
    hide-details
    bottom
    right
    color="#e7ab5f"
    @click="toTop"
  >
  <v-layout pt-1 justify-center  wrap>
    <v-flex align-self-center  >
       <v-icon>mdi-apple-keyboard-control</v-icon>
    </v-flex>
  </v-layout>
   
  </v-btn>
</template>
<script>
export default {
  name: "toTop",

  components: {},

  data: () => ({
    fab: false,
  }),
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>